<template lang="pug">
  .c-highlights
    .c-highlights--loaded
      PackageTeaser(v-if='listFull' :packageLists='packageList' :dateFormat='dateFormat' :timeFormat='timeFormat')
</template>

<script>
import packageSchema from './utils/schemas/package.js'
import PackageTeaser from '@/components/PackageTeaser.vue'
import axios from 'axios'

export default {
  name: 'Package',
  props: ['packageData'],
  components: {
    PackageTeaser
  },
  data() {
    return {
      packageList: [],
      listFull: false,
      dateFormat: this.getDateFormat(),
      timeFormat: this.getTimeFormat()
    }
  },
  created() {
    let vm = this
    let pageType = 'undefined'
    let pageId = 'undefined'
    if (window.dataLayer.length > 0) {
      // fill up data for proper attribution
      if (window.dataLayer[0].hasOwnProperty('pageType')) {
        pageType = window.dataLayer[0].pageType
      }
      if (window.dataLayer[0].hasOwnProperty('pagePath')) {
        // for black pearl pages
        pageId = window.dataLayer[0].pagePath
      }
      if (window.dataLayer[0].hasOwnProperty('pagePostId')) {
        pageId = window.dataLayer[0].pagePostId
      }
    }
    if (window.gtm_tracking !== undefined && window.gtm_tracking !== null) {
      if (window.gtm_tracking.hasOwnProperty('pageType')) {
        pageType = window.gtm_tracking.pageType
      }
      if (window.gtm_tracking.hasOwnProperty('pagePath')) {
        // for black pearl pages
        pageId = window.gtm_tracking.pagePath
      }
      if (window.gtm_tracking.hasOwnProperty('pagePostId')) {
        pageId = window.gtm_tracking.pagePostId
      }
    }
    this.packageData.product = pageType
    this.packageData.pageid = pageId
    let searchData = packageSchema.setPackageSchema(this.packageData)
    axios
      .post('https://tm.holidaypirates.group/v1/search', searchData, {
        headers: ''
      })
      .then(function(response) {
        if (response.data.data.ranks[0].items.length > 0) {
          vm.packageList.push(response.data)
          vm.listFull = true
        }
      })
  },
  methods: {
    getDateFormat() {
      if (this.$store.getters.getLocale === 'en-US') {
        return 'MM/DD/YYYY'
      }
      return 'DD.MM.YYYY'
    },
    getTimeFormat() {
      let timeFormat = 'HH:mm'
      return timeFormat
    }
  }
}
</script>
